import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';

export default (props) => (
  <Edit {...props}>
    <SimpleForm redirect="show">
      <TextInput source="name" />
      <TextInput source="description" multiline />
      <TextInput source="email" type="email" />
      <TextInput source="facebookLink" type="url" />
      <TextInput source="instagramLink" type="url" />
      <TextInput source="twitterLink" type="url" />
    </SimpleForm>
  </Edit>
);
